// Libraries
window.axios = require('axios');

/*
|--------------------------------------------------------------------------
| Vue.js
|--------------------------------------------------------------------------
*/
import Vue from 'vue';
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import VueInfiniteLoading from 'vue-infinite-loading';
import VueLazyload from 'vue-lazyload';
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';
import router from './router';
import store from './store';
import {accessToken} from '@/methods/AccessToken.js';
import {isAdmin} from '@/methods/isAdmin.js';

// Authentication - Axios interceptors
axios.interceptors.request.use(function (config) {
    if (accessToken.get.tokenType() && accessToken.get.accessToken()) {
        config.headers.Authorization = accessToken.get.tokenType() + ' ' + accessToken.get.accessToken();
    }
    return config;
});

// Authentication - Navigation guards
router.beforeEach((to, from, next) => {
    const isPrivate = (process.env.VUE_APP_AUTH == 'true');
    const isLoggedIn = store.getters.isLoggedIn;
    if (to.path.includes('/auth/')) {
        if (isLoggedIn) {
            // Proceed to page
            next({path: '/'});
        }
        else {
            next();
        }
    }
    else {
        if (isLoggedIn || !isPrivate) {
            if (!isLoggedIn) {
                if (to.path.includes('/account/')) {
                    next({path: '/'});
                }
            }
            else {
                axios.get(process.env.VUE_APP_API_URL + '/api/user/authenticated')
                .catch(error => {
                    if (error.response.status === 401) {
                        accessToken.delete()
                        isAdmin.delete()
                        store.dispatch('logout')
                        location.reload()
                    }
                })
            }

            // Proceed to page
            next();
        }
        else {
            next({path: '/auth/login'});
        }
    }
});

// BootstrapVue
Vue.use(BootstrapVue);

// Infinite Loading
Vue.use(VueInfiniteLoading);

// Lazy Load
Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: '/static/img/loading-lazy.gif',
    attempt: 3
});

// Cookies
Vue.use(VueCookies);

// Google Analytics
Vue.use(VueAnalytics, {
    id: 'UA-110223657-3',
    router
});

// App
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
